import { render, staticRenderFns } from "./ObjectTreeNode.vue?vue&type=template&id=6c55fd63&scoped=true&"
import script from "./ObjectTreeNode.vue?vue&type=script&lang=js&"
export * from "./ObjectTreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c55fd63",
  null
  
)

export default component.exports